import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { Button, ButtonGroup } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../app/hooks";
import { LoadState } from "../../../../redux/common";
import { PresenceEnum } from "../../../../redux/curriculum/model";
import { findPresenceChangeRequest, presenceChange, PresenceChangeRequest, selectPresenceInsUpd } from "../../../../redux/curriculum/presenceChangeSlice";
import { StudentPresenceInfo } from "../../../../redux/curriculum/presenceListSlice";

interface PresenceActionButtonsProps {
    subjectPerformedId: number;
    presence: StudentPresenceInfo;
    disabled: boolean;
}

const PresenceActionButtons = ({ subjectPerformedId, presence, disabled }: PresenceActionButtonsProps) => {
    const dispatch = useAppDispatch();
    const persenceInsUpd = useSelector(selectPresenceInsUpd);

    const requestData = {
        subjectPerformedId: subjectPerformedId,
        studentId: presence.student.id,
        present: presence?.presence?.present || PresenceEnum.UNKNOWN
    } as PresenceChangeRequest;

    const request = findPresenceChangeRequest(persenceInsUpd.requests, requestData);
    const state = request?.state.state || LoadState.NotStarted;

    return <ButtonGroup variant="outlined" size="small">
        <Button
            color="success"
            variant={presence?.presence?.present == PresenceEnum.PRESENT ? "contained" : "outlined"}
            disabled={state == LoadState.Loading || disabled}
            onClick={() => {
                const data = { ...requestData, present: PresenceEnum.PRESENT } as PresenceChangeRequest;
                dispatch(presenceChange(data));
            }}>
            <DoneIcon />
        </Button>
        <Button
            color="error"
            variant={presence?.presence?.present == PresenceEnum.ABSENT ? "contained" : "outlined"}
            disabled={state == LoadState.Loading || disabled}
            onClick={() => {
                const data = { ...requestData, present: PresenceEnum.ABSENT } as PresenceChangeRequest;
                dispatch(presenceChange(data));
            }}>
            <CloseIcon />
        </Button>
    </ButtonGroup>;
};

export default PresenceActionButtons;